<template>
  <transition name="opgave">
    <div v-if="opgave" class="card" @click="onClick(opgave)">
      <h1>{{opgave.titel}}</h1>
      <p>{{opgave.beskrivelse}}</p>
      <p v-if="opgave.geodkobjekter" class="secondary">{{opgave.geodkobjekter.length}} ændringer</p>
    </div>
    <div v-else class="card empty">
      <p>(Mappen er tom)</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    opgave: Object, // { id: Number, titel: String, beskrivelse: String, vejkode?: Number, geodkobjekter?: Number[], bbox?: Number[4] }
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
.card h1 {
  color: $default-color;
}

.card p {
  color: $text-color;
}

p.secondary {
  color: $text-secondary-color;
}

.card {
  width: 300px;
  min-height: 293px;
  font-size: 16px;
  padding: 37px;
  margin: 10px;
  cursor: pointer;
  background-color: #FFFFFF;
  transition: $transition-length;
  border-radius: 4px;
  box-shadow: 0 5px 20px 0 rgba(128,152,213,0.07);
  border: solid 1px #FFFFFF;
  text-align: center;

  &.empty {
    border: dashed 1px #B0B3C7;
    background-color: transparent;
    padding-top: 110px;
    cursor: unset;
    box-shadow: unset;
    p {
      color: #B0B3C7;
      font-weight: 600px;
    }
  }
}
.card:hover {
  box-shadow: 0 5px 20px 0 rgba(92,109,150,0.20);
  border: solid 1px $default-color;

  &.empty {
    box-shadow: unset;
    border: dashed 1px #B0B3C7;
  }
}
</style>
